import React, { useEffect } from "react";
import CardSkeleton from "../../components/Skeleton/CardSkeleton";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useGetProducts } from "../../hooks/useGetProducts";
import "./AllProducts.css";

function AllProducts() {
  const genre = useSelector((state) => state.genre.genre);
  const genreID = useSelector((state) => state.genre.id);
  const navigate = useNavigate();
  const { data: allProducts, isLoading } = useGetProducts(1, genreID);

  useEffect(() => {
    if (genre) navigate(`/discover/${genre}`);
  }, [genre, navigate]);

  return (
    <section className="AllProducts">
      {isLoading
        ? Array.from({ length: 8 }).map((_, index) => (
            <CardSkeleton key={index} width={"95%"} height={200} />
          ))
        : allProducts?.map((product) => (
            <Link
              to={`/product/${product.slug.toLowerCase()}`}
              className={`product ${product.slug}`}
              key={product.slug}
            >
              <img src={product.images[0].src} alt={product.name} />
              <p className="product-card-name">{product.name}</p>
            </Link>
          ))}
    </section>
  );
}

export default AllProducts;
